import { Box } from "@mui/material";
import React, { ReactNode } from "react";

type FormBoxProps = {
  children: ReactNode;
  mt?: number;
  gap?: number;
};

const FormBox: React.FC<FormBoxProps> = ({ children, mt = 0, gap = 2 }) => {
  return (
    <Box
      component="form"
      mt={mt}
      display="flex"
      flexDirection="column"
      gap={gap}
    >
      {children}
    </Box>
  );
};

export default FormBox;
